import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取预配的BI图表
export function getDefaultBi(params) {
  return request({
    url: URL.external.businessIntelligenceChart.getDefaultBi,
    method: 'get',
    params
  })
}

// 获取预配的BI图表分类
export function classify(params) {
  return request({
    url: URL.external.businessIntelligenceChart.classify,
    method: 'get',
    params
  })
}

// 获取自己的图表列表
export function getMyChart(params) {
  return request({
    url: URL.external.businessIntelligenceChart.getMyChart,
    method: 'get',
    params
  })
}

// 可用图表数和总数
export function chartConfig(params) {
  return request({
    url: URL.external.businessIntelligenceChart.chartConfig,
    method: 'get',
    params
  })
}

// 添加图表
export function addChart(data) {
  return request({
    url: URL.external.businessIntelligenceChart.addChart,
    method: 'post',
    data
  })
}

// 删除图表
export function deleteChart(params) {
  return request({
    url: URL.external.businessIntelligenceChart.deleteChart,
    method: 'delete',
    params
  })
}

// 编辑图表
export function editChart(data) {
  return request({
    url: URL.external.businessIntelligenceChart.editChart,
    method: 'put',
    data
  })
}

